module.exports = __webpack_public_path__ + "img/hero-showcase.62aa55a5.png";